<div class="m-15 wrapper" style="position: relative">
  @if (data != null && data.tier != null && data.tier != "pro") {
    <div class="not-pro-message-wrapper">
      <div class="not-pro-icon">
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M78.625 37.5H75.5V25C75.5 11.2125 64.2875 0 50.5 0C36.7125 0 25.5 11.2125 25.5 25V37.5H22.375C17.2083 37.5 13 41.7042 13 46.875V90.625C13 95.7958 17.2083 100 22.375 100H78.625C83.7917 100 88 95.7958 88 90.625V46.875C88 41.7042 83.7917 37.5 78.625 37.5ZM33.8333 25C33.8333 15.8083 41.3083 8.33333 50.5 8.33333C59.6917 8.33333 67.1667 15.8083 67.1667 25V37.5H33.8333V25ZM54.6667 69.675V79.1667C54.6667 81.4667 52.8042 83.3333 50.5 83.3333C48.1958 83.3333 46.3333 81.4667 46.3333 79.1667V69.675C43.8542 68.2292 42.1667 65.5708 42.1667 62.5C42.1667 57.9042 45.9042 54.1667 50.5 54.1667C55.0958 54.1667 58.8333 57.9042 58.8333 62.5C58.8333 65.5708 57.1458 68.2292 54.6667 69.675Z"
              fill="#C7700A"
            />
          </g>
        </svg>
      </div>
    </div>
  }

  <div class="filters-row">
    @if (data.access_level == 1) {
      <div
        class="btn-group"
        dropdown
        [autoClose]="true"
        placement="bottom left"
        [isDisabled]="selectedJobs.length === 0"
      >
        <button
          dropdownToggle
          type="button"
          class="btn btn-primary dropdown-toggle"
          aria-controls="actions-dropdown"
          [ngClass]="{ disabled: selectedJobs.length === 0 }"
        >
          Actions <span class="caret"></span>
        </button>
        <ul
          id="actions-dropdown"
          *dropdownMenu
          class="dropdown-menu dropdown-menu-left"
          role="menu"
          aria-labelledby="button-basic"
          style="z-index: 999999"
        >
          <li (click)="bulkChangeOwnership()">
            <a class="dropdown-item"> Change owner</a>
          </li>
          <li (click)="bulkUpdateStatus()">
            <a class="dropdown-item"> Update Status</a>
          </li>
          <li (click)="bulkAddTags()">
            <a class="dropdown-item"> Add tags</a>
          </li>
          <li (click)="bulkRemoveTags()">
            <a class="dropdown-item"> Remove tags</a>
          </li>
        </ul>
      </div>
    }

    <span
      dropdown
      class="dropdown"
      [autoClose]="true"
      container="body"
      style="cursor: pointer"
    >
      <span
        id="userDropdown"
        dropdownToggle
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="feather user"></i>
        <span class="sort-by">
          {{ dashboardService.filters()[dashboardName]?.personFilter?.label }}
        </span>
        <i class="feather chevron-down"></i>
      </span>
      <ul
        *dropdownMenu
        class="dropdown-menu"
        aria-labelledby="dLabel"
        role="menu"
      >
        <li role="menuitem">
          <a class="dropdown-item" (click)="changePersonFilter('me')">Me</a>
        </li>
        @if ([ROLE_MANAGER, ROLE_ADMIN].includes(userPermissions?.role)) {
          <li role="menuitem">
            <a class="dropdown-item" (click)="changePersonFilter('everyone')"
              >Everyone</a
            >
          </li>
          <li class="divider dropdown-divider"></li>
          @for (accountant of jobsStore.company.accountants; track accountant) {
            <li role="menuitem" (click)="changePersonFilter(accountant.user)">
              <a class="dropdown-item">{{ accountant.user.full_name }}</a>
            </li>
          }
        }
      </ul>
    </span>

    @if (selectedDisplayType == "list") {
      <span
        dropdown
        class="dropdown"
        [autoClose]="true"
        style="cursor: pointer"
      >
        <span
          id="dLabel"
          dropdownToggle
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <i class="feather calendar"></i>
          <span class="sort-by">
            {{ dashboardService?.filters()[dashboardName]?.dateFilter?.label }}
          </span>
          <i class="feather chevron-down"></i>
        </span>
        <ul class="dropdown-menu" aria-labelledby="dLabel" *dropdownMenu>
          <li role="menuitem" (click)="changeTimeFilter('not_completed')">
            <a class="dropdown-item">Not Completed</a>
          </li>
          <li role="menuitem" (click)="changeTimeFilter('urgent')">
            <a class="dropdown-item">Urgent</a>
          </li>
          <li role="menuitem" (click)="changeTimeFilter('overdue')">
            <a class="dropdown-item">Overdue</a>
          </li>
          <li role="menuitem" (click)="changeTimeFilter('completed')">
            <a class="dropdown-item">Completed</a>
          </li>
          <li role="menuitem" (click)="changeTimeFilter('all')">
            <a class="dropdown-item">All</a>
          </li>
        </ul>
      </span>

      @if (
        dashboardService?.filters()[this.dashboardName]
          .isCompletedFilterSelected
      ) {
        <span
          dropdown
          class="dropdown"
          [autoClose]="true"
          style="cursor: pointer"
        >
          <span
            id="dLabel"
            dropdownToggle
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="feather calendar"></i>
            <span class="sort-by">
              {{
                dashboardService?.filters()[dashboardName]
                  ?.selectedCompletedFilter?.label
              }}
            </span>
            <i class="feather chevron-down"></i>
          </span>
          <ul class="dropdown-menu" aria-labelledby="dLabel" *dropdownMenu>
            <li role="menuitem" (click)="changeSelectedFilter('all')">
              <a class="dropdown-item">All</a>
            </li>
            <li
              role="menuitem"
              (click)="changeSelectedFilter('completed_7_days')"
            >
              <a class="dropdown-item">Completed this week</a>
            </li>
            <li
              role="menuitem"
              (click)="changeSelectedFilter('completed_30_days')"
            >
              <a class="dropdown-item">Completed this month</a>
            </li>
          </ul>
        </span>
      } @else {
        <span
          dropdown
          #dropdownRef="bs-dropdown"
          class="dropdown"
          style="cursor: pointer"
        >
          <span
            id="dLabel"
            dropdownToggle
            type="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="feather calendar"></i>
            <span class="sort-by">
              {{
                dashboardService?.filters()[dashboardName]?.dueDateFilter?.label
              }}
            </span>
            <i class="feather chevron-down"></i>
          </span>
          <ul
            style="min-width: 280px; overflow: visible"
            class="dropdown-menu"
            aria-labelledby="dLabel"
            *dropdownMenu
          >
            <li
              role="menuitem"
              (click)="changeDueDateFilter('all'); dropdownRef.hide()"
            >
              <a class="dropdown-item">All due dates</a>
            </li>
            <li
              role="menuitem"
              (click)="changeDueDateFilter('overdue'); dropdownRef.hide()"
            >
              <a class="dropdown-item">Overdue</a>
            </li>
            <li
              role="menuitem"
              (click)="changeDueDateFilter('today'); dropdownRef.hide()"
            >
              <a class="dropdown-item">Due Today</a>
            </li>
            <li
              role="menuitem"
              (click)="changeDueDateFilter('this_week'); dropdownRef.hide()"
            >
              <a class="dropdown-item">Due This Week</a>
            </li>
            <li
              role="menuitem"
              (click)="changeDueDateFilter('this_month'); dropdownRef.hide()"
            >
              <a class="dropdown-item">Due This Month</a>
            </li>
            <li style="pointer-events: auto">
              <p-datepicker
                selectionMode="range"
                placeholder="Select custom date range"
                dateFormat="yy.mm.dd"
                dataType="string"
                showClear="true"
                [(ngModel)]="customDueDate"
                (onSelect)="onDateSelected()"
                [styleClass]="'calendar-dropdown'"
              ></p-datepicker>
            </li>
          </ul>
        </span>
      }
    }

    <span
      class="dropdown"
      dropdown
      container="body"
      [autoClose]="true"
      style="cursor: pointer"
      [insideClick]="true"
      (onShown)="onDropdownShown()"
    >
      <span
        dropdownToggle
        id="clientsDropdown"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="feather user"></i>
        <span class="sort-by">
          {{ dashboardService?.filters()[dashboardName]?.clientFilter?.label }}
        </span>
        <i class="feather chevron-down"></i>
      </span>
      <ul
        *dropdownMenu
        class="dropdown-menu p-relative"
        role="menu"
        aria-labelledby="clientsDropdown"
      >
        <li style="top: -9px; position: sticky; background: #fff">
          <div class="py-2 position-relative">
            <input
              #searchInput
              type="text"
              class="form-control"
              placeholder="Search clients"
              [(ngModel)]="filterText"
              (ngModelChange)="filterClients()"
            />
            <i
              [hidden]="!filterText.length"
              class="tio-clear"
              style="
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                cursor: pointer;
                opacity: 0.5;
                font-size: 20px;
              "
              (click)="clearSearch()"
            >
            </i>
          </div>
        </li>
        <li role="menuitem" (click)="changeClientFilter('all')">
          <a class="dropdown-item">All clients</a>
        </li>

        <li class="divider dropdown-divider"></li>

        @for (client of filteredClients | activeClientsOnly; track client) {
          <li
            role="menuitem"
            (click)="
              changeClientFilter({ id: client?.uuid, name: client?.name })
            "
          >
            <a class="dropdown-item">{{ client?.name }}</a>
          </li>
        }
      </ul>
    </span>

    <ng-template #workspaceExtension>
      @if (workspace_tags_filter.length > 0) {
        <h4 style="font-size: 20px">Selected tags:</h4>
      }
      @if (workspace_tags_filter.length > 0) {
        <p style="font-size: 14px">
          Show items with
          <b>{{
            andOrWorkspaces == "and"
              ? "all"
              : andOrWorkspaces == "or"
                ? "any"
                : "none"
          }}</b>
          of these tags:
        </p>
      }
      @for (tag of workspace_tags_filter; track tag) {
        <ch-tag
          [name]="tag.name"
          [color]="tag.color"
          (click)="removeTagFromFilter(tag, 'workspace')"
        ></ch-tag>
      }
      @if (workspace_tags_filter.length > 0) {
        <div>
          <hr />
          <button class="btn btn-default" (click)="clearFilter('workspace')">
            Clear
          </button>
        </div>
      }
    </ng-template>

    <ng-template #jobExtension>
      @if (job_tags_filter.length > 0) {
        <h4 style="font-size: 20px">Selected tags:</h4>
      }
      @if (job_tags_filter.length > 0) {
        <p style="font-size: 14px">
          Show items with
          <b>{{
            andOrJobs == "and" ? "all" : andOrJobs == "or" ? "any" : "none"
          }}</b>
          of these tags:
        </p>
      }
      @for (tag of job_tags_filter; track tag) {
        <ch-tag
          [name]="tag.name"
          [color]="tag.color"
          (click)="removeTagFromFilter(tag, 'job')"
        ></ch-tag>
      }
      @if (workspace_tags_filter.length > 0) {
        <div>
          <hr />
          <button class="btn btn-default" (click)="clearFilter('job')">
            Clear
          </button>
        </div>
      }
    </ng-template>

    <ng-template #jobFilterIcon>
      <div style="display: inline-block">Job Tag</div>
      <div
        style="display: inline-block; margin-left: 8px"
        class="tag-add"
        tooltip="Filter by tags"
      >
        @if (job_tags_filter.length == 0) {
          <i class="tio-filter_outlined" style="opacity: 0.6"></i>
        }
        @if (job_tags_filter.length > 0) {
          <i class="tio-filter filter-filled"></i>
        }
      </div>
    </ng-template>

    <ng-template #workspaceFilterIcon>
      <div style="display: inline-block">Client Tag</div>
      <div
        style="display: inline-block; margin-left: 8px"
        class="tag-add"
        tooltip="Filter by tags"
      >
        @if (workspace_tags_filter.length == 0) {
          <i class="tio-filter_outlined" style="opacity: 0.6"></i>
        }
        @if (workspace_tags_filter.length > 0) {
          <i class="tio-filter filter-filled"></i>
        }
      </div>
    </ng-template>

    <ch-tag-add
      #workspaceFilterTagList
      [existingTags]="workspace_tags_filter"
      [removeTagOnClick]="true"
      (tagClick)="addTagToFilter($event, 'workspace')"
      [extension]="workspaceExtension"
      [icon]="workspaceFilterIcon"
      (andOrFilterChanged)="changeAndOrFilterWorkspaces($event)"
    ></ch-tag-add>

    <ch-tag-add
      #jobFilterTagList
      [existingTags]="job_tags_filter"
      [removeTagOnClick]="true"
      (tagClick)="addTagToFilter($event, 'job')"
      [extension]="jobExtension"
      [icon]="jobFilterIcon"
      (andOrFilterChanged)="changeAndOrFilterJobs($event)"
    ></ch-tag-add>

    <div class="display-type">
      <span>View as:</span>
      <i
        class="feather list"
        [ngClass]="{ active: selectedDisplayType == 'list' }"
        (click)="changeDisplayType('list')"
        tooltip="List"
      ></i>
      <i
        class="feather card-view"
        [ngClass]="{ active: selectedDisplayType == 'column' }"
        (click)="changeDisplayType('column')"
        tooltip="Cards"
      ></i>
      <button class="btn btn-primary" (click)="openNewJobModal(createJobModal)">
        Add new job
      </button>
      @if (selectedDisplayType == "list") {
        <span
          class="btn-group export-button"
          dropdown
          [autoClose]="true"
          placement="bottom right"
        >
          <button
            dropdownToggle
            type="button"
            class="btn btn-success dropdown-toggle"
            aria-controls="dropdown-basic"
          >
            Export <span class="caret"></span>
          </button>
          <ul
            id="dropdown-basic"
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right"
            role="menu"
            aria-labelledby="button-basic"
            style="z-index: 999999"
          >
            <li (click)="triggerExportExcel()" class="p-button-success mr-2">
              <a class="dropdown-item">
                <i class="feather table"></i>
                Export to .xls</a
              >
            </li>
            <li (click)="triggerExportPdf()" class="p-button-warning mr-2">
              <a class="dropdown-item">
                <i class="feather table"></i>
                Export to .pdf</a
              >
            </li>
            <li (click)="triggerExportCsv()" class="p-button-warning mr-2">
              <a class="dropdown-item">
                <i class="feather table"></i>
                Export to .csv</a
              >
            </li>
          </ul>
        </span>
      }
    </div>
  </div>

  <ng-template #createJobModal>
    <div class="modal-header">
      <button
        type="button"
        class="btn-close"
        (click)="bsModalRef.hide()"
        aria-label="Close"
      >
        <i class="feather x"></i>
      </button>
      <h4 class="modal-title">Create new job</h4>
    </div>
    <div class="modal-body text-center">
      <i class="feather clipboard x3" style="color: #0075ff"></i>
      <h4>Choose the workspace where this Job should be added:</h4>
      <input
        [(ngModel)]="duplicateSelected"
        (typeaheadOnSelect)="selectClient($event)"
        [typeahead]="dashboardStore.clients | activeClientsOnly"
        typeaheadOptionField="name"
        [typeaheadOptionsLimit]="9999"
        [typeaheadMinLength]="0"
        placeholder="Choose a workspace"
        class="form-control"
      />
    </div>
    <div class="modal-footer">
      <div
        class="btn btn-default pull-left"
        aria-label="Cancel"
        (click)="bsModalRef.hide()"
      >
        Cancel
      </div>
      <button
        class="btn btn-primary pull-right"
        [disabled]="duplicateSelected == null || duplicateSelected == ''"
        (click)="addNewJob()"
      >
        Create Job
      </button>
    </div>
  </ng-template>

  @if (selectedDisplayType == "column") {
    <div class="ch-panels" [ngClass]="{ blocked: data.tier != 'pro' }">
      <!-- Column -->
      @for (track of tracks; track track) {
        <div class="ch-panel {{ track.css_name }}-column">
          <!-- Title -->
          <div class="ch-panel-title">
            {{ track.title }}
            @if (track.title == "Planned") {
              <i
                class="feather info"
                style="font-size: 1.15rem; color: #485364"
                tooltip="Jobs with start date within next 7 days that haven't been started"
              ></i>
            }
            @if (track.title == "Completed") {
              <i
                class="feather info"
                style="font-size: 1.15rem; color: #485364"
                tooltip="Jobs completed within past 7 days"
              ></i>
            }
            <div class="view-type d-flex">
              {{ jobs[track.id]?.length }}
            </div>
          </div>
          <!-- Job List -->
          <div class="ch-panel-content">
            <div
              class="ch-tabs-content-wrapper component-loading"
              id="{{ track.id }}"
              dragula="PROGRESS_TRACKS"
              [(dragulaModel)]="jobs[track.id]"
            >
              @for (j of jobs[track.id]; track j) {
                <div class="ch-tabs-content">
                  <app-jobs-and-tasks-card
                    class="dashboard-card"
                    [job]="j"
                    (click)="selectJob(j, track.id)"
                  >
                  </app-jobs-and-tasks-card>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (selectedDisplayType == "list") {
    <ch-job-list-view
      [exportExcelEvent]="exportExcelEvent"
      [exportPdfEvent]="exportPdfEvent"
      [exportCsvEvent]="exportCsvEvent"
      #jobListView
      [filters]="{
        selectedFilter:
          dashboardService?.filters()[dashboardName]?.personFilter?.value,
        job_tags_filter,
        workspace_tags_filter,
        selectedDateFilter:
          dashboardService?.filters()[dashboardName]?.dateFilter?.value,
        andOrJobs,
        andOrWorkspaces,
        clientFilter:
          dashboardService?.filters()[dashboardName]?.clientFilter.value,
        selectedCompletedFilter:
          dashboardService?.filters()[dashboardName]?.selectedCompletedFilter
            ?.value,
        dueDateFilter:
          dashboardService?.filters()[dashboardName]?.dueDateFilter?.value,
      }"
      [isCompletedFilterSelected]="
        dashboardService?.filters()[dashboardName].isCompletedFilterSelected
      "
      style="margin-top: 20px"
    ></ch-job-list-view>
  }

  <!-- Job modal -->
  <div
    class="job-modal"
    [ngClass]="{ open: openModal, blocked: data.tier != 'pro' }"
  >
    <div class="modal-close" (click)="closeJobContent()">
      <i class="feather x"></i>
    </div>

    <!-- Job content -->
    @if (job != null && job?.uuid != null) {
      <app-job-content [job]="job" [templateManager]="false"></app-job-content>
    }
  </div>
</div>
<div class="job-modal-backdrop" (click)="closeJobContent()"></div>
